import { FrequencyOption, FREQUENCY_OPTIONS, AutomaticMeasureFrequencies } from '../types/measure.interface';

export class FrequencyUtils {
  static getFrequencyDisplay(frequency: AutomaticMeasureFrequencies | null | undefined): string {
    if (frequency == null) return '';
    const option = FREQUENCY_OPTIONS.find(opt => opt.id === frequency);
    return option ? option.name : `${frequency} minutes`;
  }

  static getFrequencyOptions(): FrequencyOption[] {
    return [...FREQUENCY_OPTIONS];
  }

  static isValidFrequency(frequency: number): frequency is AutomaticMeasureFrequencies {
    return Number.isInteger(frequency) && frequency >= 1 && frequency <= 12;
  }

  static getFrequencyOption(frequency: AutomaticMeasureFrequencies): FrequencyOption | undefined {
    return FREQUENCY_OPTIONS.find(opt => opt.id === frequency);
  }
}
